import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import CmdApp from "@/cmd/CmdApp";
import PublicQuoteView from "@/pages/trade/quotes/PublicQuoteView";
import POGenPublic from "@/pages/trade/po/POGenPublic";
import JournalPublic from "@/pages/founder/JournalPublic";
import "@/App.css";

/**
 * EEPL Command Room is now the only app served on exploraorg.com.
 * The legacy EEPL dashboard routes have been removed.
 * The three public share pages are retained so previously shared
 * external links (quotes / PO documents / journal entries) keep working.
 */
export default function App() {
  return (
    <>
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/cmd/*" element={<CmdApp />} />
          {/* Public no-auth share links from the legacy app — kept alive */}
          <Route path="/quote/:token" element={<PublicQuoteView />} />
          <Route path="/po-doc/:token" element={<POGenPublic />} />
          <Route path="/journal/:token" element={<JournalPublic />} />
          {/* Everything else → Command Room */}
          <Route path="*" element={<Navigate to="/cmd" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
